import { get } from "storefront/GrailedAPI/request";
import type { Options } from "storefront/GrailedAPI/request/Options";
import type { Id } from "storefront/lib/Id";
import type {
  PendingOffer,
  PendingOffersResponse,
} from "storefront/Offer/PendingOffer";

// Filtering defensively here since the API types offer.listing.coverPhotoUrl as nullable.
// https://www.grailed.com/internal/api-docs#tag/Offers/operation/getPendingOffersForSeller
const unpack = (res: PendingOffersResponse): Array<PendingOffer> =>
  res.data.filter(
    (offer): offer is PendingOffer => offer.listing.coverPhotoUrl !== null,
  );

const getPending = (userId: Id, opts?: Options): Promise<Array<PendingOffer>> =>
  get<PendingOffersResponse>(
    `/api/users/${userId}/offers/pending`,
    undefined,
    opts,
  ).then(unpack);

export default getPending;
